import { CLASSROOM_MODULE_DISPLAY_REVERT_MODAL } from '../actions';
import { getVersions } from '../api';
import * as materialsSelectors from '../selectors';
import { AulaReduxAction } from '../../types/state';
import { ActionStatus } from '@core/constants/actionsStatus';
import { getCurrentSpaceId } from '../../selectors/space';
import pushRoute from '@app/utils/routing';

const displayRevertModalAction = (status: ActionStatus, payload: unknown) => ({
  type: CLASSROOM_MODULE_DISPLAY_REVERT_MODAL,
  status,
  payload,
});

type DisplayRevertModalActionFactory = (
  sectionId?: string,
  educatorOnly?: boolean
) => AulaReduxAction;

const displayRevertModal: DisplayRevertModalActionFactory =
  (sectionId, educatorOnly) => async (dispatch, getState) => {
    const state = getState();
    const classRoom = getCurrentSpaceId(state);
    // The material may not be in the store yet (e.g. on a hard refresh straight onto the version route).
    // Fallback: we just require sectionId to fetch all versions
    const existingSection = materialsSelectors?.getMaterial(state, sectionId);
    const section =
      existingSection ?? (sectionId ? { id: sectionId } : undefined);

    const payload = {
      classRoom,
      section,
    };
    dispatch(displayRevertModalAction('started', payload));

    // Check if its a mobile screen, if its a mobile screen update the path
    const isMobileScreen = window.matchMedia('(max-width: 899px)').matches;
    if (isMobileScreen && sectionId) {
      const tab = educatorOnly ? 'educatorArea' : 'materials';
      const hash = window.location.hash || '';
      const queryIndex = hash.indexOf('?');
      const queryString = queryIndex === -1 ? '' : hash.slice(queryIndex);
      let newPath = `/dashboard/${classRoom}/journey/${tab}/${sectionId}/version/list${queryString}`;
      pushRoute(newPath);
    }

    if (!sectionId) {
      // Without a sectionId there is nothing we can fetch.
      dispatch(displayRevertModalAction('error', payload));
      return;
    }

    try {
      const versions = await getVersions(classRoom, sectionId, educatorOnly);
      dispatch(
        displayRevertModalAction('success', {
          ...payload,
          section: { ...section, versions },
        })
      );
    } catch (error: unknown) {
      dispatch(displayRevertModalAction('error', payload));
    }
  };

export default displayRevertModal;
